import * as React from 'react';

// Utils
import { useTranslation } from 'react-i18next';
// Constants
// Actions
// Models
import { RentalModel } from '@src/shared/src/models';
// Interfaces
// Components
import CheckoutSideBarRentalInfoItem from './CheckoutSideBarRentalInfoItem';
// Styles

type Props = {
  rental: RentalModel;
};

const CheckoutSideBarRentalInfo: React.FC<Props> = ({ rental }) => {
  const { t } = useTranslation();
  const aggregatorIdent = rental.rentalSearch.aggregator.effectiveIdent;

  return (
    <>
      <CheckoutSideBarRentalInfoItem
        aggregatorIdent={aggregatorIdent}
        title={t('CheckoutSideBar.titel.rentalPickUp')}
        route={rental.rentalSearch.depStationName}
      />
      <CheckoutSideBarRentalInfoItem
        aggregatorIdent={aggregatorIdent}
        title={t('CheckoutSideBar.titel.rentalReturn')}
        route={rental.rentalSearch.arrStationName}
      />
    </>
  );
};

export default CheckoutSideBarRentalInfo;
